<template>

  <popup
    button-style="text"
    :heading="'Details for ' + rowData.name"
    button-text="Charts"
    button-size="mini"
    :show-save="false"
    button-icon="fa fa-chart-pie">

    <el-row :gutter="24">

      <el-col :sm="24" :md="24" :lg="24">
        <div class="dash-heading">{{rowData.name}}</div>
      </el-col>

      <el-col :sm="24" :md="24" :lg="24">
        <op-stats :stats="rowData" :org-id="rowData.organisation_id" />
        <br />
      </el-col>

      <el-col v-if="hasSites" :sm="24" :md="12" :lg="hasRequests ? 10 :  24">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span class="text-primary"><i class="fa fa-broadcast-tower" />&nbsp;Sites</span>
          </div>

          <sites-chart :stats="rowData" />

        </el-card>

      </el-col>


      <el-col v-if="hasRequests" :sm="24" :md="12" :lg="hasSites ? 14 :  24">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <span class="text-success"><i class="fa fa-share-alt" />&nbsp;Requests</span>
          </div>

          <requests-chart :stats="rowData" />
        </el-card>

      </el-col>



    </el-row>

  </popup>

</template>



<script>

import SitesChart from '@/components/dashboard/charts/SitesChart'
import RequestsChart from '@/components/dashboard/charts/RequestsChart'

import OpStats from '@/components/dashboard/OpStats'

export default {

  props: {

    rowData: {
      type: Object,
      required: true
    }

  },

  components: {
    SitesChart,
    RequestsChart,
    OpStats
  },

  computed: {

    hasSites: function () {
      return this.rowData.sitesTotal > 0
    },

    hasRequests: function () {
      return this.rowData.rta > 0 || this.rowData.rts > 0 || this.rowData.rtu > 0 || this.rowData.rtb > 0 || this.rowData.rtd > 0
    },

    hasTickets: function () {
      return this.rowData.tickets > 0
    }

  },
/*
  created () {
    console.log('PSS rowData', this.rowData)
  }
*/
}

</script>



// WEBPACK FOOTER //
// PopupSharerStats.vue?792c4e50